// React
import * as React from 'react';
import { Box } from '@mui/material/index';

export const AnnounceNudgeAction = ({ message = '' }) => {
  return <Box fontSize={14}>{message}</Box>;
};
